<template>
  <!-- 预埋单没有用到 -->
  <div id="exchanges" style="height:100%;">
    <div class="box" :class="{enRealTimeTransCC: isEnRealTimeTransCC}">
      <div class="main">
        <!-- 交易 -->
        <ul v-show="tradeType=='x'" class="content">
          <!-- 买入 -->
          <li id="middleMargin" class="left">
            <div v-if="sessionInfoGetter.isLogin=='false'">
              <div style="margin-top:30px"></div>
            </div>
            <div v-else>
              <ul class="top">
                <li class="message">
                  <span class="mb3">可用 </span>
                  <span>{{ balance1?Number(balance1).toFixed(2):'--' }}</span>
                </li>
                <li class="message_right" @click="seePrePay">预览</li>
              </ul>
            </div>
            <ul class="price">
              <li class="message">
                <span style="font-size:14px;color:#61688a;width: 16%;display: inline-block;">买入价:</span>
                <input ref="prices" v-model.number="price" type="number" step="0.01" class="sty" onmousewheel="return false;" @input="limitBuyPrice" @keyup.enter="shortcuts_F2()">
                <span></span>
                <span style="display:none">{{ Number(prices).toFixed(2) }}</span>
                <span style="position:absolute;top:10px;right:20px;color:#61688a;">{{ units }}</span>
              </li>
              <li class="message">
                <span style="font-size:14px;color:#61688a;width: 16%;display: inline-block;">买入量:</span>
                <input ref="num" v-model.number="num" type="number" step="0.01" class="sty" onmousewheel="return false;" @input="limitBuyNumber" @keyup.enter="transBuy()">
                <span style="position:absolute;top:10px;right:20px;color:#61688a;">{{ unit }}</span>
              </li>
            </ul>
            <div class="buyStep">
              <el-slider
                v-model="value1"
                show-stops
                :format-tooltip="formatTooltip"
                :disabled="disable"
                :step="25"
                @change="buyAmountset"
              >
              </el-slider>
            </div>
            <ul class="sum">
              <li class="message">
                <span class="priceText">交易额：</span>
                <span class="priceNum">{{ isNaN(price*num)?'--':(price*num*selectCommodityStrategy.unitNumeral).toFixed(2) }} {{ units }}</span>
              </li>
              <li class="message">
                <span class="priceText">保证金：</span>
                <span class="priceNum">{{ isNaN(price*num)?'--':(selectCommodityStrategy.marginType=='1'?num*selectCommodityStrategy.margin*selectCommodityStrategy.unitNumeral:price*num*selectCommodityStrategy.margin*selectCommodityStrategy.unitNumeral).toFixed(2) }} {{ units }}</span>
              </li>
              <li class="message">
                <span class="priceText">手续费：</span>
                <span class="priceNum">{{ isNaN(price*num)?'--':(selectCommodityStrategy.openFeeType=='1'?num*selectCommodityStrategy.openFee*selectCommodityStrategy.unitNumeral:price*num*selectCommodityStrategy.openFee*selectCommodityStrategy.unitNumeral).toFixed(2) }} {{ units }}</span>
              </li>
            </ul>
            <div v-if="sessionInfoGetter.isLogin=='true'">
              <input style="color:#fff;background-color:#fa5252;font-size:14px;" type="button" class="btn" :value="'买入开多 '+unit" :disabled="yesNo" @click="transBuy()">
            </div>
            <div v-else class="btnA" style="background-color:#12B886;text-align:center;line-height:34px;">
              <router-link to="/login" class="login" style="font-size:16px;font-wight:600;">登录</router-link>
              <span class="word">或</span>
              <!-- <router-link to="/register" class="register" style="font-size:16px;font-wight:600;">注册</router-link> -->

            </div>
          </li>
          <!-- 卖出 -->
          <li class="left">
            <div v-if="sessionInfoGetter.isLogin=='false'">
              <div style="margin-top:30px"></div>
            </div>
            <div v-else>
              <ul class="top">
                <li class="message" style="width:80%">
                  <span class="mb3">可用  </span>
                  <span>{{ balance2?Number(balance2).toFixed(2):'--' }}</span>
                </li>
                <li v-if="unit=='ETH'||unit=='BTC'||unit=='USDT'" class="chong" @click="toMyAccount(unit)">
                  充值
                </li>
              </ul>
            </div>
            <ul class="price">
              <li class="message">
                <span style="font-size:14px;color:#61688a;width: 16%;display: inline-block;">卖出价:</span>
                <input ref="sellprices" v-model.number="sell" type="number" step="0.01" class="sty" onmousewheel="return false;" @input="limitSellPrice" @keyup.enter="shortcuts_F4()">
                <span style="display:none">{{ sells }}</span>
                <span style="position:absolute;top:10px;right:20px;color:#61688a;">{{ units }}</span>
              </li>
              <li class="message">
                <span style="font-size:14px;color:#61688a;width: 16%;display: inline-block;">卖出量:</span>
                <input ref="sellnum" v-model.number="number" type="number" step="0.01" class="sty" onmousewheel="return false;" @input="limitSellNumber" @keyup.enter="transSell()">
                <span style="position:absolute;top:10px;right:20px;color:#61688a;">{{ unit }}</span>
              </li>
            </ul>
            <div class="tradStep">
              <el-slider
                v-model="value2"
                show-stops
                :format-tooltip="formatTooltip"
                :step="25"
                @change="sellAmountset"
              >
              </el-slider>
            </div>
            <ul class="sum">
              <li class="message">
                <span class="priceText">交易额：</span>
                <span class="priceNum">{{ isNaN(sell*number)?'--':(sell*number*selectCommodityStrategy.unitNumeral).toFixed(2) }} {{ units }}</span>
              </li>
              <li class="message">
                <span class="priceText">保证金：</span>
                <span class="priceNum">{{ isNaN(sell*number)?'--':(selectCommodityStrategy.sellMarginType=='1'?number*selectCommodityStrategy.sellMargin*selectCommodityStrategy.unitNumeral:sell*number*selectCommodityStrategy.sellMargin*selectCommodityStrategy.unitNumeral).toFixed(2) }} {{ units }}</span>
              </li>
              <li class="message">
                <span class="priceText">手续费：</span>
                <span class="priceNum">{{ isNaN(sell*number)?'--':(selectCommodityStrategy.openFeeType=='1'?number*selectCommodityStrategy.openFee*selectCommodityStrategy.unitNumeral:sell*number*selectCommodityStrategy.openFee*selectCommodityStrategy.unitNumeral).toFixed(2) }} {{ units }}</span>
              </li>
            </ul>
            <div v-if="sessionInfoGetter.isLogin=='true'">
              <input style="color:#fff;font-size:14px" type="button" class="btn" :value="'卖出开空 '+unit" :disabled="yesNo2" onkeyup="this.value=this.value.replace(/^\d+\.?\d{0,2}$/)" @click="transSell()">
            </div>
            <div v-else class="btnA" style="background-color:#FA5252;text-align:center;line-height:34px">
              <router-link to="/login" class="login" style="font-size:16px;font-wight:600;">登录</router-link>
              <span class="word">或</span>
              <!-- <router-link to="/register" class="register" style="font-size:16px;font-wight:600;">注册</router-link> -->
            </div>
          </li>
        </ul>
      </div>
    </div>
    <span style="display:none">{{ data }}</span>
    <el-dialog id="PrePay_Dialog" title="预埋单预览" :visible.sync="isSeePrePayDia" class="stop-profit-loss">
      <el-table :data="prePayArr" style="width: 100%;min-height: 400px;">
        <template slot="empty">
          <div class="no-datas1"><div class="no-data-img" style="margin: 100px auto 0px; width: 100px; height: 100px;"><img src="../../../assets/images/no_data.png" alt="" style="width: 100%;"></div><div class="no-data" style="margin-top: -15px !important; text-align: center;">暂无数据</div></div>
        </template>
        <el-table-column label="商品">
          <template slot-scope="scope">
            {{ scope.row.unit }}
          </template>
        </el-table-column>
        <el-table-column label="买卖方向">
          <template slot-scope="scope">
            {{ scope.row.param.bsFlag=='B'?'买入':'卖出' }}
          </template>
        </el-table-column>
        <el-table-column label="价格">
          <template slot-scope="scope">
            {{ scope.row.param.price }}
          </template>
        </el-table-column>
        <el-table-column label="数量">
          <template slot-scope="scope">
            {{ scope.row.param.quantity }}
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="100"
        >
          <template slot-scope="scope">
            <el-button type="warning" size="small" @click="handleClick(scope)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
/* global hqProtocol hqWs protocol http */
import { mapGetters } from 'vuex'
export default {
  name: 'RealTimeTransCC',
  data() {
    return {
      passwordShow1: false,
      radio: 0,
      isChangedDisable: false,
      priceTrue: false,
      TotalMoney: '21.0000003',
      message: '费率',
      isTrue: true,
      isTrueA: false,
      num: '',
      number: '',
      yesNo: false,
      yesNo2: false,
      yesNo3: false,
      yesNo4: false,
      sell: ' ',
      price: '',
      balance1: null,
      balance2: null,
      isEnRealTimeTransCC: false,
      lt1: '',
      lt2: '',
      value1: [0, 10],
      value2: 0,
      disable: false,
      selectGood: false,
      goodName: '',
      goodMemo: '',
      addrCopy: '',
      addr: '',
      dialogChargeVisible: false,
      currentChargeCoin: '',
      tq_onKeyCode_A: false,
      tq_onKeyCode_Shift: false,
      tq_onKeyCode_Ctrl: false,
      tq_onKeyCode_Alt: false,
      tq_onKeyCode_F1: false,
      tq_onKeyCode_F2: false,
      tq_onKeyCode_F3: false,
      tq_onKeyCode_F4: false,
      tq_onKeyCode_Q: false,
      tq_onKeyCode_W: false,
      tq_onKeyCode_E: false,
      tq_onKeyCode_R: false,
      tq_onKeyCode_X: false,
      tq_onKeyCode_C: false,
      tq_onKeyCode_V: false,
      tq_onKeyCode_B: false,
      tq_onKeyCode_G: false,
      tq_onKeyCode_left: false,
      tq_onKeyCode_up: false,
      tq_onKeyCode_right: false,
      tq_onKeyCode_down: false,

      tradeType: 'x', // x限价 s市价

      isSeePrePayDia: false,
      prePayArr: []
    }
  },
  computed: {
    ...mapGetters(['sessionInfoGetter', 'item', 'myassetDataGetter', 'commodityStrategyGetter', 'h_avilibleMargin', 'isChangeMarginPsdGetter']),
    data() {
      const item = this.$store.state.hqData.item.symbolId
      if (item) {
        return item
      } else {
        if (this.$store.state.hqData.marketDetails.length > 0) {
          return this.$store.state.hqData.marketDetails[0].symbolId
        } else {
          return '--'
        }
      }
    },
    selectCommodityStrategy() {
      if (this.data !== '--' && this.commodityStrategyGetter.length > 0) {
        for (const CommodityStrategy of this.commodityStrategyGetter) {
          if (this.data == CommodityStrategy.commodityId) {
            return CommodityStrategy
          }
        }
      } else if (this.data == '--' && this.commodityStrategyGetter.length > 0) {
        return this.commodityStrategyGetter[0]
      }
      return {
        canBuy: '--',
        canDqDelivery: '--',
        canSell: '--',
        canShow: '--',
        canTqDelivery: '--',
        canTqTransfer: '--',
        canTransfer: '--',
        commodityCode: '--',
        commodityId: null,
        commodityName: '--',
        feeStrategyId: '--',
        guidePrice: '--',
        holdStrategyId: '--',
        margin: '--',
        marginStrategyId: '--',
        marginType: '--',
        marketPrice: '--',
        maxHoldAmount: '--',
        maxSingleTradeAmount: '--',
        maxUpDownWidth: '--',
        minAmountChange: 0.01,
        minPickupAmount: '--',
        minPriceChange: 0.01,
        minSingleTradeAmount: '--',
        offerEndTime: 0,
        openFee: '--',
        openFeeType: '--',
        pickupCountdown: '--',
        pickupStandard: '--',
        pickupStartTime: 0,
        tradeStrategyId: '--',
        transferFee: '--',
        transferFeeType: '--',
        unitNumeral: '--',
        unitQuantifier: '--',
        sellMargin: '--',
        sellMarginType: '--'
      }
    },
    unit() {
      const item = this.$store.state.hqData.item.symbol
      if (item) {
        const strDian = item.split('/')
        const strDianQian = strDian[0]
        return strDianQian
      } else {
        if (this.$store.state.hqData.marketDetails.length > 0) {
          return this.$store.state.hqData.marketDetails[0].symbol.split('/')[0]
        } else {
          return ''
        }
      }
    },
    units() {
      const item = this.$store.state.hqData.item.symbol
      if (item) {
        const strDian = item.split('/')
        const strDianQian = strDian[1]
        return strDianQian
      } else {
        if (this.$store.state.hqData.marketDetails.length > 0) {
          return this.$store.state.hqData.marketDetails[0].symbol.split('/')[1]
        } else {
          return ''
        }
      }
    },
    sells() {
      const item = this.$store.state.hqData.item.close
      if (item) {
        return Number(item).toFixed(this.coinSmallDigital.coinDigitalNum)
      } else {
        if (this.$store.state.hqData.marketDetails.length > 0) {
          return Number(this.$store.state.hqData.marketDetails[0].close).toFixed(this.coinSmallDigital.coinDigitalNum)
        } else {
          return '--'
        }
      }
    },
    prices() {
      const item = this.$store.state.hqData.item.close
      if (item) {
        return Number(item).toFixed(this.coinSmallDigital.coinDigitalNum)
      } else {
        if (this.$store.state.hqData.marketDetails.length > 0) {
          return this.$store.state.hqData.marketDetails[0].close
        } else {
          return '--'
        }
      }
    },
    buyLst() {
      const item = this.$store.state.hqData.buyLst
      if (item) {
        return item
      } else {
        return '--'
      }
    },
    sellLst() {
      const item = this.$store.state.hqData.sellLst
      if (item) {
        return item
      } else {
        return '--'
      }
    },
    sellOne() {
      const item = this.$store.state.hqData.sellOne
      if (item) {
        return item
      } else {
        return '--'
      }
    },
    buyOne() {
      const item = this.$store.state.hqData.buyOne
      if (item) {
        return item
      } else {
        return '--'
      }
    },
    canBuy() {
      let num
      if (this.price > 0) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.lt1 = '<'
        num = this.balance1 / (this.price * this.selectCommodityStrategy.unitNumeral)
      } else {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.lt1 = ' '
        num = '--'
      }
      return num
    },
    canSell() {
      let num
      if (this.sell > 0) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.lt2 = '<'
        num = this.balance2 / (this.sell * this.selectCommodityStrategy.unitNumeral)
      } else {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.lt2 = ' '
        num = '--'
      }
      return num
    },
    coinSmallDigital() {
      const minPriceChange = this.selectCommodityStrategy.minPriceChange // 最小数量变动单位
      const minAmountChange = this.selectCommodityStrategy.minAmountChange // 价格价格变动单位
      let pricePoint = -Math.round(Math.log(minPriceChange) / Math.log(10))
      let amountPoint = -Math.round(Math.log(minAmountChange) / Math.log(10))
      if (pricePoint <= 0) {
        pricePoint = 0
      }
      if (amountPoint <= 0) {
        amountPoint = 0
      }
      return {
        symbolId: this.item.symbolId,
        // numStr:/^(\d+)\.(\d{0,6}).*$/,
        numStr: new RegExp('^(\\d+)\\.(\\d{0,' + pricePoint + '}).*$'),
        coinDigitalNum: pricePoint,
        quantityNum: amountPoint, // 数量
        quantityStr: new RegExp('^(\\d+)\\.(\\d{0,' + amountPoint + '}).*$'), // 数量
        buyFeePercentage: 0.03, // 买,手续费占比
        sellFeePercentage: 0.02 // 卖,手续费占比
      }
    },
    // 资产小数点位数(合约)
    coinDigitalNum() {
      return 2
    }
  },
  watch: {
    item: function(xin, jiu) {
      setTimeout(() => {
        if (
          this.buyLst.length > 0 &&
          this.buyLst[this.buyLst.length - 1][0] != '--'
        ) {
          this.sell = Number(this.buyLst[this.buyLst.length - 1][0]).toFixed(this.coinSmallDigital.coinDigitalNum)
        } else {
          this.sell = ''
        }
        if (this.sellLst.length > 0 && this.sellLst[0][0] != '--') {
          this.price = Number(this.sellLst[0][0]).toFixed(this.coinSmallDigital.coinDigitalNum)
        } else {
          this.price = ''
        }
      }, 500)
    },
    // unit: function() {
    //   if (this.sessionInfoGetter.isLogin == 'true') {
    //     this.creditAvailable()
    //   }
    // },
    // units: function() {
    //   if (this.sessionInfoGetter.isLogin == 'true') {
    //     this.creditAvailable()
    //   }
    // },
    // price(val){
    //   if(!val) return
    //     if(!/^\d*\.?\d{0,2}$/.test(val)){
    //     }
    // }
    buyOne: function(val, oldVal) {
      if (val[0] != '--') {
        this.sell = Number(val[0]).toFixed(this.coinSmallDigital.coinDigitalNum)
      } else {
        this.sell = ''
      }
    },
    sellOne: function(val, oldVal) {
      if (val[0] != '--') {
        this.price = Number(val[0]).toFixed(this.coinSmallDigital.coinDigitalNum)
      } else {
        this.price = ''
      }
    },
    buyLst() {
      if (window.g.APP_ISAUTOPRICE) {
        this.initPrice()
      }
    },
    sellLst() {
      if (window.g.APP_ISAUTOPRICE) {
        this.initPrice()
      }
    },
    h_avilibleMargin(val, oldVal) {
      if (val) {
        this.balance1 = val
        this.balance2 = val
      }
    }
  },
  created: function() {
    // this.sell = buyLst[0].amount;
    // this.price = buyLst[0].amount;
    if (this.sessionInfoGetter.isLogin == 'true') {
      // this.currency();
      this.creditAvailable()
    }
    setTimeout(() => {
      hqProtocol.param_top.symbol = this.data // this.$store.state.hqData.marketDetails[0].symbolId
      if (this.data && this.data != '--') {
        hqWs.send(hqProtocol.param_top)
      } else {
        this.init()
      }
    }, window.g.TOP_REFRESH_TIME ? window.g.TOP_REFRESH_TIME : 1000)
    // 快捷键
    const _this = this
    document.onkeydown = function(e) {
      const evn = e || event
      const key = evn.keyCode || evn.which || evn.charCode
      // A
      if (key === 65) {
        _this.tq_onKeyCode_A = true
      }
      // Shift
      if (key === 16) {
        _this.tq_onKeyCode_Shift = true
      }
      // Ctrl
      if (key === 17) {
        _this.tq_onKeyCode_Ctrl = true
      }
      // Alt
      if (key === 18) {
        _this.tq_onKeyCode_Alt = true
      }
      // Q
      if (key === 81) {
        _this.tq_onKeyCode_Q = true
      }
      // W
      if (key === 87) {
        _this.tq_onKeyCode_W = true
      }
      // E
      if (key === 69) {
        _this.tq_onKeyCode_E = true
      }
      // R
      if (key === 82) {
        _this.tq_onKeyCode_R = true
      }
      // F1
      if (key === 112) {
        _this.tq_onKeyCode_F1 = true
      }
      // F2
      if (key === 113) {
        _this.tq_onKeyCode_F2 = true
      }
      // F3
      if (key === 114) {
        _this.tq_onKeyCode_F3 = true
      }
      // F4
      if (key === 115) {
        _this.tq_onKeyCode_F4 = true
      }
      // X
      if (key === 88) {
        _this.tq_onKeyCode_X = true
      }
      // C
      if (key === 67) {
        _this.tq_onKeyCode_C = true
      }
      // V
      if (key === 86) {
        _this.tq_onKeyCode_V = true
      }
      // B
      if (key === 66) {
        _this.tq_onKeyCode_B = true
      }
      // G
      if (key === 71) {
        _this.tq_onKeyCode_G = true
      }
      // 左
      if (key === 37) {
        _this.tq_onKeyCode_left = true
      }
      // 上
      if (key === 38) {
        _this.tq_onKeyCode_up = true
      }
      // 右
      if (key === 39) {
        _this.tq_onKeyCode_right = true
      }
      // 下
      if (key === 40) {
        _this.tq_onKeyCode_down = true
      }
      // if(_this.tq_onKeyCode_Shift === true && _this.tq_onKeyCode_Ctrl === true && _this.tq_onKeyCode_A === true){
      //   _this.tq_onKeyCode_Ctrl = false
      //   _this.tq_onKeyCode_Shift = false
      //   _this.tq_onKeyCode_A = false
      //   _this.shortcuts_Ctrl_Shift_A()
      // }
      if (_this.tq_onKeyCode_Alt && _this.tq_onKeyCode_X) {
        _this.shortcuts_F1()
      }
      if (_this.tq_onKeyCode_Alt && _this.tq_onKeyCode_C) {
        _this.shortcuts_F2()
      }
      if (_this.tq_onKeyCode_Alt && _this.tq_onKeyCode_V) {
        _this.shortcuts_F3()
      }
      if (_this.tq_onKeyCode_Alt && _this.tq_onKeyCode_B) {
        _this.shortcuts_F4()
      }
      if (_this.tq_onKeyCode_Alt && _this.tq_onKeyCode_B) {
        _this.shortcuts_F4()
      }
      if (_this.tq_onKeyCode_Alt && _this.tq_onKeyCode_left) {
        _this.shortcuts_horizontal()
      }
      if (_this.tq_onKeyCode_Alt && _this.tq_onKeyCode_right) {
        _this.shortcuts_horizontal()
      }
      if (_this.tq_onKeyCode_Alt && _this.tq_onKeyCode_up) {
        _this.shortcuts_verticality()
      }
      if (_this.tq_onKeyCode_Alt && _this.tq_onKeyCode_down) {
        _this.shortcuts_verticality()
      }
    }
    document.onkeyup = function(e) {
      if (e.keyCode === 65) {
        _this.tq_onKeyCode_A = false
      }
      if (e.keyCode === 16) {
        _this.tq_onKeyCode_Shift = false
      }
      if (e.keyCode === 17) {
        _this.tq_onKeyCode_Ctrl = false
      }
      if (e.keyCode === 18) {
        _this.tq_onKeyCode_Alt = false
      }
      if (e.keyCode === 81) {
        _this.tq_onKeyCode_Q = false
      }
      if (e.keyCode === 87) {
        _this.tq_onKeyCode_W = false
      }
      if (e.keyCode === 69) {
        _this.tq_onKeyCode_E = false
      }
      if (e.keyCode === 82) {
        _this.tq_onKeyCode_R = false
      }
      if (e.keyCode === 112) {
        _this.tq_onKeyCode_F1 = false
      }
      if (e.keyCode === 113) {
        _this.tq_onKeyCode_F2 = false
      }
      if (e.keyCode === 114) {
        _this.tq_onKeyCode_F3 = false
      }
      if (e.keyCode === 115) {
        _this.tq_onKeyCode_F4 = false
      }
      // X
      if (e.keyCode === 88) {
        _this.tq_onKeyCode_X = false
      }
      // C
      if (e.keyCode === 67) {
        _this.tq_onKeyCode_C = false
      }
      // V
      if (e.keyCode === 86) {
        _this.tq_onKeyCode_V = false
      }
      // B
      if (e.keyCode === 66) {
        _this.tq_onKeyCode_B = false
      }
      // G
      if (e.keyCode === 71) {
        _this.tq_onKeyCode_G = false
      }
      // 左
      if (e.keyCode === 37) {
        _this.tq_onKeyCode_left = false
      }
      // 上
      if (e.keyCode === 38) {
        _this.tq_onKeyCode_up = false
      }
      // 右
      if (e.keyCode === 39) {
        _this.tq_onKeyCode_right = false
      }
      // 下
      if (e.keyCode === 40) {
        _this.tq_onKeyCode_down = false
      }
    }
  },
  mounted: function() {
    setTimeout(() => {
      if (
        this.buyLst.length > 0 &&
        this.buyLst[this.buyLst.length - 1][0] != '--'
      ) {
        this.sell = Number(this.buyLst[this.buyLst.length - 1][0]).toFixed(this.coinSmallDigital.coinDigitalNum)
      } else {
        this.sell = ''
      }
      if (this.sellLst.length > 0 && this.sellLst[0][0] != '--') {
        this.price = Number(this.sellLst[0][0]).toFixed(this.coinSmallDigital.coinDigitalNum)
      } else {
        this.price = ''
      }
    }, 1000)
    // 禁止input滚轮(兼容火狐)
    function MouseWheel(event) {
      event = event || window.event
      event.preventDefault()
    }
    const aInp = document.getElementsByTagName('input')
    for (let i = 0; i < aInp.length; i++) {
      aInp[i].addEventListener('DOMMouseScroll', MouseWheel, false)
    }
    // this.setLanguageCss()
    // if (this.sessionInfoGetter.isLogin == 'true') {
    //   this.getQueryparamet()
    // }
  },
  methods: {
    // 显示预埋单
    seePrePay() {
      this.prePayArr = this.comPrePayArr()
      this.isSeePrePayDia = true
    },
    // 计算预埋单数据
    comPrePayArr() {
      let PrePayArr = []
      const obj = JSON.parse(localStorage.getItem(`PrePay${this.sessionInfoGetter.tel}`))
      try {
        if (obj && obj.length > 0) {
          PrePayArr = obj
        }
      } catch (error) {
      }
      return PrePayArr
    },
    handleClick(row) {
      const nprePayArr = this.comPrePayArr()
      nprePayArr.splice(row.$index, 1)
      localStorage.setItem(`PrePay${this.sessionInfoGetter.tel}`, JSON.stringify(nprePayArr))
      this.prePayArr = nprePayArr
    },
    init() {
      setTimeout(() => {
        hqProtocol.param_top.symbol = this.data // this.$store.state.hqData.marketDetails[0].symbolId
        if (this.data && this.data != '--') {
          hqWs.send(hqProtocol.param_top)
        } else {
          this.init()
        }
      }, window.g.TOP_REFRESH_TIME ? window.g.TOP_REFRESH_TIME : 1000)
    },
    initPrice() {
      if (
        this.buyLst.length > 0 &&
        this.buyLst[this.buyLst.length - 1][0] != '--'
      ) {
        this.sell = Number(this.buyLst[this.buyLst.length - 1][0]).toFixed(this.coinSmallDigital.coinDigitalNum)
      }
      if (this.sellLst.length > 0 && this.sellLst[0][0] != '--') {
        this.price = Number(this.sellLst[0][0]).toFixed(this.coinSmallDigital.coinDigitalNum)
      }
    },
    changePasswordShow1() {
      if (this.passwordShow1 == 'password') {
        this.passwordShow1 = 'text'
      } else {
        this.passwordShow1 = 'password'
      }
    },
    changeType() {
      this.isBBToList = !this.isBBToList
    },
    changeRodio(e) {
      this.isChangedDisable = true
      this.radio = e
      let currentRo
      if (e == 2) {
        currentRo = 'USDT'
      } else if (e == 1) {
        currentRo = 'ETH'
      } else if (e == 0) {
        currentRo = 'BTC'
      }
      this.addr = ''
      this.currentChargeCoin = currentRo
      protocol.param_moneyio.param.type = 'in'
      protocol.param_moneyio.param.currency = currentRo
      protocol.param_moneyio.param.fromaddress = this.sessionInfoGetter.firmCode
      protocol.param_moneyio.param.toaddress = ''
      http.postFront(protocol.param_moneyio).then(response => {
        this.isChangedDisable = false
        const { code, message, address } = response.data
        if (code == 0) {
          this.addr = address

          this.selectGood = false
          this.addrCopy = address
          // }
          this.dialogChargeVisible = true
        } else {
          this.$message(message)
        }
      })
    },
    limitBuyPrice() {
      const numStr = this.coinSmallDigital.numStr
      if (this.$refs.prices.value.length > 2) {
        this.$refs.prices.value = this.$refs.prices.value.replace(numStr, '$1.$2')
        this.price = this.$refs.prices.value
      }
    },
    limitBuyNumber() {
      const numStr = this.coinSmallDigital.quantityStr
      if (this.$refs.num.value.length > 2) {
        this.$refs.num.value = this.$refs.num.value.replace(numStr, '$1.$2')
        this.num = this.$refs.num.value
      }
    },
    limitBuyNumber1() {
      const numStr = this.coinSmallDigital.quantityStr
      if (this.$refs.marketnum.value.length > 2) {
        this.$refs.marketnum.value = this.$refs.marketnum.value.replace(numStr, '$1.$2')
        this.num = this.$refs.marketnum.value
      }
    },
    limitSellNumber() {
      const numStr = this.coinSmallDigital.numStr
      if (this.$refs.sellnum.value.length > 2) {
        this.$refs.sellnum.value = this.$refs.sellnum.value.replace(numStr, '$1.$2')
        this.number = this.$refs.sellnum.value
      }
    },
    limitSellNumber1() {
      const numStr = this.coinSmallDigital.numStr
      if (this.$refs.marketsellnum.value.length > 2) {
        this.$refs.marketsellnum.value = this.$refs.marketsellnum.value.replace(numStr, '$1.$2')
        this.number = this.$refs.marketsellnum.value
      }
    },
    limitSellPrice() {
      const numStr = this.coinSmallDigital.quantityStr
      if (this.$refs.sellprices.value.length > 2) {
        this.$refs.sellprices.value = this.$refs.sellprices.value.replace(numStr, '$1.$2')
        this.sell = this.$refs.sellprices.value
      }
    },

    formatTooltip(val) {
      return val + '%'
    },
    // 卖数量改变
    sellAmountset(val) {
      // // let nums = global.util.floatDiv(this.balance2,this.sell)
      // const nums = Number(this.balance2) / (1 + Number(this.coinSmallDigital.sellFeePercentage)) // 计算卖出手续费
      // const current = val / 100
      // const sliderNum = global.util.floatMul(nums, current)
      // // this.number = Number(sliderNum).toFixed(this.coinSmallDigital.quantityNum)

      // const num = Number(sliderNum)
      // const precisionNum = Math.pow(10, this.coinSmallDigital.quantityNum)
      // this.number = (Math.floor(num * precisionNum) / precisionNum).toFixed(this.coinSmallDigital.quantityNum)

      // let margin = 0.01// 默认不取0
      // if (this.selectCommodityStrategy.marginType == '1') {
      //   margin = this.selectCommodityStrategy.margin
      // } else {
      //   margin = Number(this.sell) * this.selectCommodityStrategy.margin
      // }
      let sellMargin = 0.01// 默认不取0
      if (this.selectCommodityStrategy.sellMarginType == '1') {
        sellMargin = this.selectCommodityStrategy.sellMargin
      } else {
        sellMargin = Number(this.sell) * this.selectCommodityStrategy.sellMargin
      }
      let openFee = 0.01// 默认不取0
      if (this.selectCommodityStrategy.openFeeType == '1') {
        openFee = this.selectCommodityStrategy.openFee
      } else {
        openFee = Number(this.sell) * this.selectCommodityStrategy.openFee
      }
      const current = val / 100
      const returnNum = global.util.floatMul((this.balance2 / (sellMargin + openFee)), current)
      this.number = Math.floor(Number(Number(returnNum) / this.selectCommodityStrategy.unitNumeral))
    },
    buyAmountset(val) {
      // this.balance1
      // this.price
      // 可买量
      let margin = 0.01// 默认不取0
      if (this.selectCommodityStrategy.marginType == '1') {
        margin = this.selectCommodityStrategy.margin
      } else {
        margin = Number(this.price) * this.selectCommodityStrategy.margin
      }
      let openFee = 0.01// 默认不取0
      if (this.selectCommodityStrategy.openFeeType == '1') {
        openFee = this.selectCommodityStrategy.openFee
      } else {
        openFee = Number(this.price) * this.selectCommodityStrategy.openFee
      }
      const current = val / 100
      const returnNum = global.util.floatMul((this.balance1 / (margin + openFee)), current)
      this.num = Math.floor(Number(Number(returnNum) / this.selectCommodityStrategy.unitNumeral))
    },
    transSell: function() {
      if (this.isChangeMarginPsdGetter) {
        return this.$message('请先修改资金密码')
      }
      const obj = JSON.parse(localStorage.getItem(`settingDea${this.sessionInfoGetter.tel}`))
      if (obj === true || obj === 'true') {
        const _this = this
        this.$alert('确认下单?', '提示', {
          confirmButtonText: '确定',
          callback: action => {
            _this.transSellControl()
          }
        })
      } else {
        this.transSellControl()
      }
    },
    transSellControl() {
      this.yesNo2 = true
      if (this.number == '') {
        this.shortcuts_F4()
        this.$message('请输入卖出数量')
        this.yesNo2 = false
      } else {
        if (this.sell < 0) {
          this.shortcuts_F3()
          this.$message('请输入不小于0的卖出价!')
          this.yesNo2 = false
        } else if (this.sell == '') {
          this.shortcuts_F3()
          this.$message('请输入卖出价')
          this.yesNo2 = false
        } else if (this.number < 0) {
          this.shortcuts_F3()
          this.$message('卖出量不可小于0!')
          this.yesNo2 = false
        } else if (isNaN(this.sell)) {
          this.shortcuts_F1()
          this.$message('请输入价格!')
          this.yesNo = false
        } else {
          const protocolPrePay = protocol.param_trades
          protocolPrePay.unit = this.unit
          protocolPrePay.param.price = this.sell
          protocolPrePay.param.quantity = this.number
          protocolPrePay.param.bsFlag = 'S'
          protocolPrePay.param.commodityId = this.data
          let PrePayArr = []
          const obj = JSON.parse(localStorage.getItem(`PrePay${this.sessionInfoGetter.tel}`))
          try {
            if (obj && obj.length > 0) {
              PrePayArr = obj
            }
          } catch (error) {
          }
          if (PrePayArr.length >= 10) {
            PrePayArr.shift()// 删除头部元素
          }
          PrePayArr.push(protocolPrePay)

          localStorage.setItem(`PrePay${this.sessionInfoGetter.tel}`, JSON.stringify(PrePayArr))

          this.$message({ message: `预埋单设置成功,最多可设置10条,剩余可设置${10 - PrePayArr.length}条`, duration: 3000 })
          this.yesNo2 = false
        }
      }
    },
    transBuy: function() {
      if (this.isChangeMarginPsdGetter) {
        return this.$message('请先修改资金密码')
      }
      const obj = JSON.parse(localStorage.getItem(`settingDea${this.sessionInfoGetter.tel}`))
      if (obj === true || obj === 'true') {
        const _this = this
        this.$alert('确认下单?', '提示', {
          confirmButtonText: '确定',
          callback: action => {
            _this.transBuyControl()
          }
        })
      } else {
        this.transBuyControl()
      }
    },
    transBuyControl() {
      this.yesNo = true
      if (this.num == '') {
        this.shortcuts_F2()
        this.$message('请输入买入数量')
        this.yesNo = false
      } else {
        if (this.price < 0) {
          this.shortcuts_F1()
          this.$message('请输入不小于0的买入价!')
          this.yesNo = false
        } else if (this.price == '') {
          this.shortcuts_F1()
          this.$message('请输入买入价')
          this.yesNo = false
        } else if (this.num < 0) {
          this.shortcuts_F1()
          this.$message('买入量不可小于0!')
          this.yesNo = false
        } else if (isNaN(this.price)) {
          this.shortcuts_F1()
          this.$message('请输入价格!')
          this.yesNo = false
        } else {
          // const that = this
          const protocolPrePay = protocol.param_trades
          protocolPrePay.unit = this.unit
          protocolPrePay.param.price = this.price
          protocolPrePay.param.quantity = this.num
          protocolPrePay.param.bsFlag = 'B'
          protocolPrePay.param.commodityId = this.data
          let PrePayArr = []
          const obj = JSON.parse(localStorage.getItem(`PrePay${this.sessionInfoGetter.tel}`))
          try {
            if (obj && obj.length > 0) {
              PrePayArr = obj
            }
          } catch (error) {
          }
          if (PrePayArr.length >= 10) {
            PrePayArr.shift()// 删除头部元素
          }
          PrePayArr.push(protocolPrePay)

          localStorage.setItem(`PrePay${this.sessionInfoGetter.tel}`, JSON.stringify(PrePayArr))
          this.$message({ message: `预埋单设置成功,最多可设置10条,剩余可设置${10 - PrePayArr.length}条`, duration: 3000 })
          this.yesNo = false
        }
      }
    },
    // 市价
    marketSell: function() {
      const obj = JSON.parse(localStorage.getItem(`settingDea${this.sessionInfoGetter.tel}`))
      if (obj === true || obj === 'true') {
        const _this = this
        this.$alert('确认下单?', '提示', {
          confirmButtonText: '确定',
          callback: action => {
            _this.marketSellControl()
          }
        })
      } else {
        this.marketSellControl()
      }
    },
    marketSellControl() {
      this.yesNo4 = true
      if (this.number == '') {
        this.shortcuts_F4()
        this.$message('请输入卖出数量')
        this.yesNo4 = false
      } else {
        if (this.number < 0) {
          this.shortcuts_F3()
          this.$message('卖出量不可小于0!')
          this.yesNo4 = false
        } else {
          const that = this
          protocol.param_marketTake.param.quantity = this.number
          protocol.param_marketTake.param.bsFlag = 'S'
          protocol.param_marketTake.param.commodityId = this.data
          http.postFront(protocol.param_marketTake).then(response => {
            this.yesNo4 = false
            if (response.status == -404) {
              return this.$message({
                message: '下单失败',
                duration: 1000
              })
            }
            if (response.data && response.data.code == '0') {
              this.$message({ message: response.data.message, duration: 1000 })
              this.creditAvailable()
              // this.sell = ''
              if (Number(this.buyLst[this.buyLst.length - 1][0]) > 0) {
                this.sell = Number(this.buyLst[this.buyLst.length - 1][0]).toFixed(this.coinSmallDigital.coinDigitalNum)
                this.shortcuts_F4()
              } else {
                this.sell = ''
                this.shortcuts_F3()
              }
              this.number = ''
            } else if (response.data.code == '-10035') {
              this.$message('请您先进行实名认证再进行交易')
              this.$router.push('/usercenter/highCertification')
            } else {
              this.$message({ message: response.data.message, duration: 1000 })
            }
          })
        }
      }
    },
    marketBuy: function() {
      const obj = JSON.parse(localStorage.getItem(`settingDea${this.sessionInfoGetter.tel}`))
      if (obj === true || obj === 'true') {
        const _this = this
        this.$alert('确认下单?', '提示', {
          confirmButtonText: '确定',
          callback: action => {
            _this.marketBuyControl()
          }
        })
      } else {
        this.marketBuyControl()
      }
    },
    marketBuyControl() {
      this.yesNo3 = true
      if (this.num == '') {
        this.shortcuts_F2()
        this.$message('请输入买入数量')
        this.yesNo3 = false
      } else {
        if (this.num < 0) {
          this.shortcuts_F1()
          this.$message('买入量不可小于0!')
          this.yesNo3 = false
        } else {
          const that = this
          protocol.param_marketTake.param.quantity = this.num
          protocol.param_marketTake.param.bsFlag = 'B'
          protocol.param_marketTake.param.commodityId = this.data
          http.postFront(protocol.param_marketTake).then(response => {
            this.yesNo3 = false
            if (response.status == -404) {
              return this.$message({
                message: '下单失败',
                duration: 1000
              })
            }
            if (response.data && response.data.code == '0') {
              this.$message({ message: response.data.message, duration: 1000 })
              this.creditAvailable()
              // this.price = ''
              if (Number(this.sellLst[0][0]) > 0) {
                this.price = Number(this.sellLst[0][0]).toFixed(this.coinSmallDigital.coinDigitalNum)
                this.shortcuts_F2()
              } else {
                this.price = ''
                this.shortcuts_F1()
              }
              this.num = ''
            } else if (response.data.code == '-10035') {
              this.$message('请您先进行实名认证再进行交易')
              this.$router.push('/usercenter/highCertification')
            } else {
              this.$message({ message: response.data.message, duration: 1000 })
            }
          })
        }
      }
    },
    // 可用币种数据
    creditAvailable() {
      this.balance1 = this.h_avilibleMargin
      this.balance2 = this.h_avilibleMargin
    },
    // 根据语言改变样式
    setLanguageCss() {
      // 防止清缓存后数据消失
      this.$i18n.locale =
        localStorage.lang || navigator.language.slice(-2).toLowerCase()
      switch (localStorage.lang) {
        case 'en':
          localStorage.setItem('isEnRealTimeTransCC', true)
          this.isEnRealTimeTransCC = localStorage.isEnRealTimeTransCC
          break
        default:
          break
      }
    },
    // 快捷键触发事件
    shortcuts_F1(event) {
      this.$refs.prices.focus()
    },
    shortcuts_F2(event) {
      if (this.tradeType == 'x') {
        this.$refs.num.focus()
      } else {
        this.$refs.marketnum.focus()
      }
    },
    shortcuts_F3(event) {
      this.$refs.sellprices.focus()
    },
    shortcuts_F4(event) {
      if (this.tradeType == 'x') {
        this.$refs.sellnum.focus()
      } else {
        this.$refs.marketsellnum.focus()
      }
    },
    // 水平
    shortcuts_horizontal(event) {
      if (this.$refs.prices === document.activeElement) {
        this.shortcuts_F3()
      } else if (this.$refs.sellprices === document.activeElement) {
        this.shortcuts_F1()
      } else if (this.$refs.num === document.activeElement) {
        this.shortcuts_F4()
      } else if (this.$refs.sellnum === document.activeElement) {
        this.shortcuts_F2()
      } else if (this.$refs.marketnum === document.activeElement) {
        this.shortcuts_F4()
      } else if (this.$refs.marketsellnum === document.activeElement) {
        this.shortcuts_F2()
      }
    },
    // 垂直
    shortcuts_verticality(event) {
      if (this.$refs.prices === document.activeElement) {
        this.shortcuts_F2()
      } else if (this.$refs.sellprices === document.activeElement) {
        this.shortcuts_F4()
      } else if (this.$refs.num === document.activeElement) {
        this.shortcuts_F1()
      } else if (this.$refs.sellnum === document.activeElement) {
        this.shortcuts_F3()
      }
    },
    lowPriceEnter() {
      this.$refs.dialog_highPrice.focus()
    }
  }
}
</script>
<style scoped lang="scss">
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type="number"] {
  -moz-appearance: textfield;
}
.currentCoin{
   background-color:transparent;
   height: 110px;
   .currentRodio{
     height:50px;
     line-height:50px;
     padding-left:10px;
   }
   .currentDian{
     display:inline-block;
     width: 25%;
     line-height:50px;
     text-indent:10px;
     /* border-bottom:1px solid #131625; */
   }
  .currentAddress{
    display: inline-block;
    height: 40px;
    line-height: 40px;
    width:82%;
    margin:5px 0 5px 10px;
    border:1px solid rgba(111, 142, 255, 0.5);
    text-indent:10px;
    color: #BFC3CE;
  }
  .currentCopy{
    line-height: 40px;
    display: inline-block;
    width: 14%;
    padding-left: 18px;
    box-sizing: border-box;
    color: #BFC3CE;
  }

}
  .tip .tips p{
    line-height: 30px;
  }
.box {
  width: 100%;
  height: 100%;
  background-color: #131625;
  /* border-top: 35px solid #111217; */
  .main {
    width: 100%;
    /* padding-left: 25px; */
    margin: 0 auto;
    box-sizing: border-box;
    .title {
      height: 35px;
      margin-bottom: 10px;
      color: #B0B8DB;
      :last-child {
        float: right;
        margin-right: -150px;
      }
      li {
        float: left;
        line-height: 35px;
        font-size: 14px;
        width: 70px;
        margin-right: 39px;
        /* text-align: center; */
      }
    }
    .content {
      width: 100%;
      height: 100%; // 与金额对齐
      padding-top: 5px;
      border-top: none !important;
      .priceText {
        /* display: inline-block; */
        overflow: hidden;
        color:#61688a;

      } //最大数值的限制,样式
      .priceNum {
        /* display: inline-block; */
        /* width: 105px; */
        // overflow: hidden;
      }
      li {

        /* float:left;
        width: 50%;
        box-sizing:border-box; */
      } // 买入
      .buyStep{
        padding-left:15px;
      }
      .left {
        float:left;
        width: 48%;
        box-sizing:border-box;
        height: 100%;
        padding: 0 15px 0 40px;
        .hx {
          /* height: 19px;
          margin-bottom: 11px;
          font-size:16px; */
          .login,
          .register {
            font-size: 14px;
            color: white;

          }
          .word,
          .start {
            font-size: 12px;
            color: #556d89;
          }
        }
        .top {
          position: relative;
          font-size: 14px;
          width: 97%;
          height: 15px;
          margin-bottom: 30px;
           color:#61688a ;
          .message {
            width: 80%;
            float: left;
          }
          .chong {
            position: absolute;
            /* top: 20px; */
            right: 0px;
            width: 35px;
            text-align: right;
            color: #99ccff;
            cursor: pointer;
            font-weight: 900;
          }
          .huazhuan {
            position: absolute;
            /* top: 20px; */
            right: 75px;
            width: 35px;
            text-align: right;
            color: #99ccff;
            cursor: pointer;
            font-weight: 900;
          }
          .chargeMoney{
            right: 0;
          }
          .fee{
              right: -20px;
              a{
                  color: #99ccff;
              }

          }
        } // 买入里第二个ul
        /* .price {
          height: 20px;
          margin-bottom: 12px;
          .message {
            width: 80%;
            float: left;
          }
          .chong {
            width: 20%;
            text-align: right;
          }
        } */
        .price {

          .message {
            width: 100%;

            position: relative;
            margin-bottom: 5px;
          }
          .chong {
            /* width: 20%; */
            text-align: right;
          }
        }
        .sty {
          height: 34px;
          border: 1px solid rgba(78, 89, 133, 1);
          border-radius: 5px;
          background-color: rgba(19,22,37,.2);
          width: 80%;
          outline-style: none;
        }
        .unit {
          position: absolute;
          display: inline-block;
          top: 216px;
          left: 45px;
        }
        .sum {
          font-size: 14px;
          width: 100%;
          height: 15px;
          margin-bottom: 20px;
          color:#61688a !important;
          .message {
            width: 33%;
            float: left;
          }
          .chong {
            //以前是40%
            /* width: 20%; */
            display: none;
            text-align: right;
          }
        }
        .btn {
          background-color: #12b886;
          height: 34px;
          border-radius: 5px;
          width: 100%;
          outline-style: none;
          margin-bottom: 10px;
          border: 0;
          display: block;
          margin: 10px auto;
          font-weight: bold;

        }
        .btnA {
          background-color: #4e5985;
          height: 34px;
          border-radius: 5px;
          width: 64%;
          outline-style: none;
          margin-bottom: 10px;
          border: 0;
          display: block;
          margin: 10px auto;
          a{
            color:#fff;
          }
          span{
            color:#fff;
          }
          .login:hover,
          .register:hover {
            // color:#7D7E7F;
            color:#fff;
          }
        }
      }
    }
  }
}
.now {
      width: 20%;
    text-align: left;
    color: #B0B8DB;
}
.rate,
.rate .rate-link {
  margin: 0 !important;
  color: #99ccff;
  cursor: pointer;
}
#middleMargin {
  padding: 0 40px 0 15px;
  border-right:1px dashed #ddd;
}
input[type="number"] {
  text-indent: 8px;
}
/* 添加了响应式布局方式 */
@media screen and (min-width: 1600px) {
  .box .main {
    // 限价交易容器
    width: 100%;
    /* margin: -40px auto 0 auto; */
    padding-left: 0 !important;
  }
  .box .main .content > li {
    // 限价交易输入框
    width: 50%;
  }
}
/* @media screen and (min-width: 1300px) {
 #middleMargin {
  margin-right: 2%;
  }
} */
.mb3 {
  margin-bottom: 3px;
}
div.enRealTimeTransCC .main .title > li {
  width: auto;
}
.marketSelectBox {
  font-size: 16px;
  color: #1f3f59;
  position: relative;
  margin: 11px 10px;
  border: 1px solid rgba(111,142,255,0.5);
  height: 80px;
  .bluePoint {
    position: absolute;
    display: none;
    font-size: 40px;
    line-height: 10px;
    color: blue;
    font-weight: bolder;
    left: 10px;
    top: 13px;
  }
  .redPoint {
    position: absolute;
    display: none;
    font-size: 40px;
    line-height: 10px;
    color: red;
    font-weight: bolder;
    left: 10px;
    bottom: 18px;
  }
  .from {
    position: absolute;
    display: inline-block;
    color: darkgray;
    line-height: 40px;
    left: 30px;
    top: 0;
  }
  .to {
    position: absolute;
    display: inline-block;
    color: darkgray;
    line-height: 40px;
    left: 30px;
    top: 40px;
  }
  .BBMarket {
    position: absolute;
    display: inline-block;
    color: #bfc3ce;
    line-height: 40px;
    top: 0;
    left: 75px;
    right: 68px;
    transition: top 0.2s;
    img {
      height: 20px;
      position: absolute;
      right: 0;
      top: 10px;
    }
  }
  .ListMarket {
    position: absolute;
    display: inline-block;
    color: #bfc3ce;
    line-height: 40px;
    bottom: 0;
    left: 75px;
    transition: top 0.2s;
  }
  .rightBox {
    position: absolute;
    display: table-cell;
    top: 0;
    right: 0;
    bottom: 0;
    width: 58px;
    text-align: center;
    vertical-align: middle;
    background: rgba(111,142,255,0.5);
    // border-left: 1px solid #bfc3ce;
    img {
      width: 30px;
      height: 30px;
      margin-top: 25px;
    }
  }
  .lineBox {
    position: absolute;
    display: inline-block;
    right: 58px;
    top: 39.5px;
    height: 1px;
    background: rgba(111,142,255,0.5);
    left: 20px;
  }
}
.inputMessagebox input {
  background: none;
  outline: none;
  text-indent: 10px;
  width: 100%;
  font-size: 14px;
  // color: #000;
  line-height: 40px;
  border: 1px solid #ddd;
}
</style>
<style scope lang="scss">
#exchanges /deep/ .el-dialog {
  // background: rgba(38, 53, 98, 1) !important;
  height: auto !important;
}
// #exchanges /deep/  .el-dialog .el-dialog__header,#exchanges /deep/  .el-dialog .el-dialog__body,#exchanges /deep/ .el-dialog .el-dialog__footer{
//   background: rgba(38, 53, 98, 1) !important;
//   padding-top: 20px;
// }
// #exchanges /deep/  .el-dialog .el-dialog__header .el-dialog__title{
//   color: #000 !important;
// }
#exchanges /deep/ .el-button {
    background-color: #fff !important;
}
#exchanges /deep/ .el-button span {
    color: #409EFF !important;
}
#exchanges /deep/ .el-button--primary {
    background-color: #409EFF !important;
    border-color: #409EFF !important;
    color: #fff !important;
}
#exchanges /deep/ .el-button--primary span {
    color: #FFF !important;
}
// #exchanges /deep/ .el-dialog__headerbtn .el-dialog__close {
//     color: #000 !important;
// }
// #exchanges /deep/ .el-radio__input.is-checked .el-radio__inner {
//     border-color: gold;
//     background: gold;
// }
.ctc-bi-btns /deep/ span{
  color:#fff;
}
.ctc-bi-btns{
  float: right;
}
.box .main .content .left .btn{
  text-align: center;
}
.message_right{
  width: 19%;
  float: right;
  text-align: center;
  border: 1px solid #2483ff;
  border-radius: 2px;
  color: #2483ff;
}

</style>
<style>
  #PrePay_Dialog .el-table {
    background: #2b3f71;
  }
  #PrePay_Dialog .el-form-item__label {
    color: #fff;
  }
  #PrePay_Dialog .stop-profit-loss .el-dialog {
    width: 517px;
    height: 400px;
    border-radius: 10px;
  }
  #PrePay_Dialog .stop-profit-loss .el-dialog__footer {
    padding:  20px;
  }
  #PrePay_Dialog .stop-profit-loss .el-dialog__footer::after {
    content: "";
    display: block;
    clear: both;
  }
  #PrePay_Dialog .el-cancel-btn span,
  #PrePay_Dialog .el-confirm-btn span {
    color: #fff !important;
  }
  #PrePay_Dialog .el-confirm-btn,
  #PrePay_Dialog .el-cancel-btn {
    float: right;
    margin-right: 14%;
    width: 135px;
    height: 36px;
    line-height: 0px;
    border: 0;
    background-color: rgba(75, 85, 127, 1) !important;
  }
  #PrePay_Dialog .el-confirm-btn {
    background-color: rgba(122, 152, 248, 1) !important;
  }
  #PrePay_Dialog .el-table--enable-row-hover .el-table__body tr:hover>td{
    background-color: rgba(180,206,255,.04) !important;
  }
  #PrePay_Dialog .el-table__footer-wrapper tbody td,#PrePay_Dialog .el-table__header-wrapper tbody td {
    background-color: #263562;
  }

  #PrePay_Dialog
  /deep/
  .el-table--striped
  .el-table__body
  tr.el-table__row--striped.current-row
  td,
#PrePay_Dialog /deep/ .el-table__body tr.current-row > td,
#PrePay_Dialog /deep/ .el-table__body tr.hover-row.current-row > td,
#PrePay_Dialog
  /deep/
  .el-table__body
  tr.hover-row.el-table__row--striped.current-row
  > td,
#PrePay_Dialog
  /deep/
  .el-table__body
  tr.hover-row.el-table__row--striped
  > td,
#PrePay_Dialog /deep/ .el-table__body tr.hover-row > td {
  background-color: #2b3f71;
}
#PrePay_Dialog /deep/ .el-table td,
#PrePay_Dialog /deep/ .el-table th {
  padding: 5px 0;
}
#PrePay_Dialog /deep/ .el-table__row:hover tr > td {
  background-color: #2b2f44;
}
#PrePay_Dialog /deep/ .el-table td,
#PrePay_Dialog /deep/ .el-table th.is-leaf {
  border: 0;
}
#PrePay_Dialog /deep/ .el-table--border::after,
#PrePay_Dialog /deep/ .el-table--group::after,
#PrePay_Dialog /deep/ .el-table::before {
  background-color: transparent;
}
#PrePay_Dialog /deep/ .el-table__fixed-right::before,
#PrePay_Dialog /deep/ .el-table__fixed::before {
  background-color: transparent;
}
#PrePay_Dialog /deep/ .bodyLine .el-table__header-wrapper {
  border-bottom: solid 1px #979797;
}
#PrePay_Dialog .el-table table tr,#PrePay_Dialog .el-table th {
  background-color: #2b3f71;
}
</style>
